module.exports = __webpack_public_path__ + "img/icon_QQ@2x.e01ab751.png";